module.exports = __webpack_public_path__ + "static/media/mailbox_gray.352e7482.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mailbox_gray.png
// module id = 778
// module chunks = 0